import { AxiosPromise } from 'axios';
import _ from 'lodash';

import AppStorage from '../../Storage/Storage';
import Requests from '../Requests';
import Draft, { DraftDto } from '../../interfaces/Draft';

export default class DraftService {
  private readonly storage: AppStorage;

  constructor() {
    this.storage = AppStorage.getInstance();
  }

  getDraftDto = (): DraftDto => {
    const storageFieldsForDraft = this.storage.getDataForDraft();
    return {
      data: JSON.stringify(storageFieldsForDraft),
    };
  };

  parseDraftDto = (draft: string): void => {
    const data = JSON.parse(draft) as Storage;
    this.storage.setDataFromDraft(data);
    if (_.isEmpty(data.personalDataFormState)) {
      throw new Error('Draft corrupted');
    }
  };

  saveDraft = (): void => {
    const draft = this.getDraftDto();
    /* Sometimes on production we have a corrupted data in the draft, investigation show that in these cases personalDataFormState is empty object.
      To avoid FE to store corrupted data, we will check it before request.
     */
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (_.isEmpty(JSON.parse(draft.data)?.personalDataFormState)) return;
    Requests.postHealthDeclarationDraft(draft)
      .then((response) => {
        console.log(response); // eslint-disable-line no-console
        console.log(JSON.parse(response.data.result.data)); // eslint-disable-line no-console
      })
      .catch((error) => {
        console.log(error); // eslint-disable-line no-console
      });
  };

  syncLater = (delay = 2000): void => {
    setTimeout(this.saveDraft, delay);
  };

  getDraft = (): AxiosPromise<Draft> => (
    Requests.getHealthDeclarationDraft()
      .catch((err) => {
        throw err;
      })
  );
}
